import React, { useEffect, useState } from "react";
import NepaliDateSelect from "./NepaliDateSelect";
import EnglishDateSelect from "./EnglishDateSelect";
import EnglishDatePicker from "./EnglishDatePicker";
import {
  SPECIFIC_USER_FAILURE,
  SPECIFIC_USER_START,
  SPECIFIC_USER_SUCCESS,
} from "../../container/user/types";
import { useStore } from "../../store";
import {
  Label,
  Select,
  SelectReport,
} from "../../assets/StyledComponent/Input/Input.Style";
import Report from "./Report";
import ReportUser from "../SuperAdminReport/UserReport/Report";
import { Capitalize } from "../../utils/Capitalize";
import { userSpecificService } from "../../services/UserService";
import { type } from "os";
import { SET_ALL_REPORT_BY_FALSE } from "../../container/FoodReport/types";

const report = ["Food Report", "Employee Report"];

const AdminFoodReport = () => {
  const [state, dispatch]: any = useStore();
  const [reportType, setReportType] = useState("" || "Food Report");

  useEffect(() => {
    dispatch({ type: SPECIFIC_USER_START });
    userSpecificService()
      .then((res: any) => {
        dispatch({
          type: SPECIFIC_USER_SUCCESS,
          specificUser: res,
        });
        // console.log(res)
      })
      .catch((err: any) => {
        dispatch({
          type: SPECIFIC_USER_FAILURE,
          specificUserError: err,
        });
      });
  }, []);

  const setTheReportHandler = (e: React.FormEvent) => {
    setReportType((e.target as any).value);
    dispatch({
      type: SET_ALL_REPORT_BY_FALSE,
    });
  };

  return (
    <>
      <div className="calenderContainerr">
        <div className="calenderWrapperMain">
          <div className="calenderWrapperr">
            <span className="head">Filters</span>
            <div className="selectDiv">
              <div
                style={{
                  width: "46%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Label
                  style={{
                    fontWeight: "500",
                    marginRight: "20px",
                  }}
                >
                  Your Company
                </Label>
                <SelectReport
                  style={{
                    width: "48%",
                  }}
                  aria-label="Default select example"
                  // {...register("company_id")}
                  id="#select"
                  className="inputTextSelect inputText selectpicker"
                >
                  <option
                    className="option"
                    value={state.userReducer?.specificUser?.company?.company_id}
                  >
                    {Capitalize(
                      state.userReducer?.specificUser?.company?.name ?? ""
                    )}
                  </option>
                </SelectReport>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "5%",
                  width: "50%",
                }}
              >
                <Label
                  style={{
                    fontWeight: "500",
                    marginRight: "20px",
                  }}
                >
                  Report Type
                </Label>
                <SelectReport
                  style={{
                    width: "44%",
                  }}
                  aria-label="Default select example"
                  // {...register("company_id")}
                  onChange={(e) => setTheReportHandler(e)}
                  id="#select"
                  className="inputTextSelect inputText selectpicker"
                >
                  {report.map((item: string, index: number) => {
                    return (
                      <option key={index} className="option" value={item}>
                        {Capitalize(item)}
                      </option>
                    );
                  })}
                </SelectReport>
              </div>
            </div>

            <EnglishDatePicker
              reportType={reportType}
              companyId={state.userReducer?.specificUser?.company?.company_id}
            />
            <NepaliDateSelect
              reportType={reportType}
              companyId={state.userReducer?.specificUser?.company?.company_id}
            />
            <EnglishDateSelect
              reportType={reportType}
              companyId={state.userReducer?.specificUser?.company?.company_id}
            />
          </div>
          {reportType === "Food Report"
            ? state.foodReportReducer?.cTotalExpenseReport &&
            (state.foodReportReducer?.enlgishSelect === true ||
              state.foodReportReducer?.nepaliDate === true ||
              state.foodReportReducer?.englishDate === true) && (
              <Report
                companyId={
                  state.userReducer?.specificUser?.company?.company_id
                }
                reportType={reportType}
                data={state.foodReportReducer?.cTotalExpenseReport}
              />
            )
            : state.SCmpUserReportReducer?.SCmpUserReport &&
            (state.foodReportReducer?.enlgishSelect === true ||
              state.foodReportReducer?.nepaliDate === true ||
              state.foodReportReducer?.englishDate === true) && (
              <ReportUser
                companyName={state.userReducer?.specificUser?.company?.name}
                companyId={
                  state.userReducer?.specificUser?.company?.company_id
                }
                reportType={reportType}
                data={state.SCmpUserReportReducer?.SCmpUserReport}
              />
            )}
        </div>
      </div>
    </>
  );
};

export default AdminFoodReport;
